import * as React from "react";
const SvgInbox = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2 7.99984V9.4665C2 10.5866 2 11.1467 2.21799 11.5745C2.40973 11.9508 2.71569 12.2568 3.09202 12.4485C3.51984 12.6665 4.07989 12.6665 5.2 12.6665H10.8C11.9201 12.6665 12.4802 12.6665 12.908 12.4485C13.2843 12.2568 13.5903 11.9508 13.782 11.5745C14 11.1467 14 10.5866 14 9.4665V7.99984M2 7.99984H4.44968C4.7758 7.99984 4.93886 7.99984 5.09231 8.03668C5.22836 8.06934 5.35842 8.12321 5.47771 8.19632C5.61227 8.27877 5.72757 8.39408 5.95817 8.62468L6.04183 8.70833C6.27243 8.93893 6.38773 9.05424 6.52229 9.13669C6.64158 9.2098 6.77164 9.26367 6.90769 9.29633C7.06114 9.33317 7.2242 9.33317 7.55032 9.33317H8.44968C8.7758 9.33317 8.93886 9.33317 9.09231 9.29633C9.22836 9.26367 9.35842 9.2098 9.47771 9.13669C9.61227 9.05424 9.72757 8.93893 9.95817 8.70833L10.0418 8.62468C10.2724 8.39408 10.3877 8.27877 10.5223 8.19632C10.6416 8.12321 10.7716 8.06934 10.9077 8.03668C11.0611 7.99984 11.2242 7.99984 11.5503 7.99984H14M2 7.99984L3.55093 4.55334C3.85835 3.87017 4.01206 3.52858 4.25351 3.27821C4.46694 3.05688 4.72852 2.88774 5.01794 2.78394C5.34534 2.6665 5.71992 2.6665 6.46907 2.6665H9.53092C10.2801 2.6665 10.6547 2.6665 10.9821 2.78394C11.2715 2.88774 11.5331 3.05688 11.7465 3.27821C11.9879 3.52858 12.1416 3.87017 12.4491 4.55334L14 7.99984",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgInbox;
